module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/accordian/accordian-style1/accordian-style1.component.scss
// module id = ./src/app/features/accordian/accordian-style1/accordian-style1.component.scss
// module chunks = main